module.exports = __webpack_public_path__ + "img/Ponte-do-Saber-Raphael-Pizzino2.5c10874c.jpg";